import { Empty } from 'antd'

export function EmptyState() {
  return <Empty description='Ask GraviChat anything about your data.' />
}
